function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsAuthorities = function SvgSettingsAuthorities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.26,30.53V31H31.76v-.47a.28.28,0,0,1,.28-.28h.47V19.56a.56.56,0,0,1,.56-.56h7.87a.56.56,0,0,1,.57.56V30.25H42A.29.29,0,0,1,42.26,30.53Zm-7.5-8.81A.28.28,0,0,0,35,22H36a.29.29,0,0,0,.28-.28v-.94A.29.29,0,0,0,36,20.5H35a.28.28,0,0,0-.28.28Zm0,2.25a.28.28,0,0,0,.28.28H36a.29.29,0,0,0,.28-.28V23a.29.29,0,0,0-.28-.28H35a.28.28,0,0,0-.28.28Zm1.5,2.25v-.94A.29.29,0,0,0,36,25H35a.28.28,0,0,0-.28.28v.94a.28.28,0,0,0,.28.28H36A.29.29,0,0,0,36.26,26.22Zm1.5,2.06a.29.29,0,0,0-.28-.28h-.94a.28.28,0,0,0-.28.28v2h1.5Zm1.5-7.5A.29.29,0,0,0,39,20.5H38a.28.28,0,0,0-.28.28v.94A.28.28,0,0,0,38,22H39a.29.29,0,0,0,.28-.28Zm0,2.25a.29.29,0,0,0-.28-.28H38a.28.28,0,0,0-.28.28V24a.28.28,0,0,0,.28.28H39a.29.29,0,0,0,.28-.28Zm0,2.25A.29.29,0,0,0,39,25H38a.28.28,0,0,0-.28.28v.94a.28.28,0,0,0,.28.28H39a.29.29,0,0,0,.28-.28Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.24,30.53V31H7.74v-.47A.29.29,0,0,1,8,30.25h.47V19.56A.56.56,0,0,1,9.06,19h7.87a.56.56,0,0,1,.56.56V30.25H18A.28.28,0,0,1,18.24,30.53Zm-7.5-8.81A.29.29,0,0,0,11,22H12a.28.28,0,0,0,.28-.28v-.94A.28.28,0,0,0,12,20.5H11a.29.29,0,0,0-.28.28Zm0,2.25a.29.29,0,0,0,.28.28H12a.28.28,0,0,0,.28-.28V23a.28.28,0,0,0-.28-.28H11a.29.29,0,0,0-.28.28Zm1.5,2.25v-.94A.28.28,0,0,0,12,25H11a.29.29,0,0,0-.28.28v.94a.29.29,0,0,0,.28.28H12A.28.28,0,0,0,12.24,26.22Zm1.5,2.06a.28.28,0,0,0-.28-.28h-.94a.29.29,0,0,0-.28.28v2h1.5Zm1.5-7.5A.28.28,0,0,0,15,20.5H14a.29.29,0,0,0-.28.28v.94A.29.29,0,0,0,14,22H15a.28.28,0,0,0,.28-.28Zm0,2.25a.28.28,0,0,0-.28-.28H14a.29.29,0,0,0-.28.28V24a.29.29,0,0,0,.28.28H15a.28.28,0,0,0,.28-.28Zm0,2.25A.28.28,0,0,0,15,25H14a.29.29,0,0,0-.28.28v.94a.29.29,0,0,0,.28.28H15a.28.28,0,0,0,.28-.28Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.24,30.53V31H19.74v-.47a.29.29,0,0,1,.28-.28h.47V19.56a.56.56,0,0,1,.57-.56h7.87a.56.56,0,0,1,.56.56V30.25H30A.28.28,0,0,1,30.24,30.53Zm-7.5-8.81A.29.29,0,0,0,23,22H24a.28.28,0,0,0,.28-.28v-.94A.28.28,0,0,0,24,20.5H23a.29.29,0,0,0-.28.28Zm0,2.25a.29.29,0,0,0,.28.28H24a.28.28,0,0,0,.28-.28V23a.28.28,0,0,0-.28-.28H23a.29.29,0,0,0-.28.28Zm1.5,2.25v-.94A.28.28,0,0,0,24,25H23a.29.29,0,0,0-.28.28v.94a.29.29,0,0,0,.28.28H24A.28.28,0,0,0,24.24,26.22Zm1.5,2.06a.28.28,0,0,0-.28-.28h-.94a.29.29,0,0,0-.28.28v2h1.5Zm1.5-7.5A.28.28,0,0,0,27,20.5H26a.29.29,0,0,0-.28.28v.94A.29.29,0,0,0,26,22H27a.28.28,0,0,0,.28-.28Zm0,2.25a.28.28,0,0,0-.28-.28H26a.29.29,0,0,0-.28.28V24a.29.29,0,0,0,.28.28H27a.28.28,0,0,0,.28-.28Zm0,2.25A.28.28,0,0,0,27,25H26a.29.29,0,0,0-.28.28v.94a.29.29,0,0,0,.28.28H27a.28.28,0,0,0,.28-.28Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsAuthorities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-authorities.8fb96716.svg";
export { ForwardRef as ReactComponent };